import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Skeleton from '@material-ui/lab/Skeleton';
import { useToasts } from 'react-toast-notifications';
import { connect } from "react-redux";
import apiCallService from "../../service/api-call-service";
import Animations from "./corporate.loader";

const AddNewInventory = ({ authenticated, token, roMdn, currentUser }) => {
    const { addToast } = useToasts()
  const [cardStartRange, setCardStartrange] = useState("");
  const [totalCard, setTotalCard] = useState("");
  const [cardExpDate, setCardExpDate] = useState("");
  const [loading, setLoading] = useState(false)
  console.log("totalCard", totalCard, cardExpDate);

  const fetchNewStartRange = async () => {
    setLoading(true)
    const url = process.env.REACT_APP_GET_CARD_SERIAL_NUM;
    console.log("fetchNewStartRange start");
    var result = await apiCallService.getMethodCallWithoutParam(url);
    console.log("fetchNewStartRange end", result);
    console.log("finalBalance 1", result);
    if (result !== undefined && result !== null) {
      let startRange = result.toString();
      const virtualIdText = startRange.substring(0, 3);
      const newSatrtRange = startRange.substring(3);
      const increaseStartRange = +newSatrtRange + 1;
      const range = virtualIdText + increaseStartRange;
      setCardStartrange(range);
      setLoading(false)
    }
    setLoading(false)
  };

  useEffect(() => {
    const getCorpStartRange = async () => {
      await fetchNewStartRange();
    };
    getCorpStartRange();

    return () => {
      // this now gets called when the component unmounts
      console.log("unmount");
    };
  }, []);
  const addNewcardHandler = async (e) => {
    e.preventDefault();
    const result = await addnewcard();
    if(result.status == 'SUCCESS'){
        addToast(result?.response_description, {
            appearance: 'success',
            autoDismiss: true,
            autoDismissTimeout: 7000
          })
          fetchNewStartRange()
          setTotalCard('')
          setCardExpDate('')
    }
  };
  const addnewcard = async () => {
    setLoading(true)
    const request = {
      request: {
        createdBy: currentUser,
        startRange: cardStartRange,
        totalcardorder: totalCard,
        cardExpiryDate: cardExpDate,
        cardType: "0",
        lastFourDigit: "2222",
      },
    };
    const url = process.env.REACT_APP_ADD_VIRTUAL_CARD;
    const response = await apiCallService.postMethodCall(url, request);
    console.log("response", response);
    setLoading(false)
    return response;
  };
const checkDisable = ()=>{
    let disabled = true;
    if(cardStartRange !== '' && totalCard !== '' && cardExpDate !== ''){
    disabled = false;
    }
    return disabled
}

  return (
    <div className="emp-container">
      <div className="container-fluid">
        <form onSubmit={addNewcardHandler}>
          <div className="row">
            {loading ? (
             <Animations />
            ) : (
              <>
                <div className="col-12">
                  <div className="head">
                    <div className="head-right">
                      <a
                        href="/corp-list"
                        data-toggle="tooltip"
                        title="Back"
                        className="back"
                      >
                        <i></i>
                      </a>
                    </div>
                    <h3>Add New Corporate</h3>
                  </div>
                </div>
                <div className="col-12">
                  <div className="add-emp-form">
                    <div className="row">
                      <div className="col-12 col-md-9 col-lg-9 col-xl-12">
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-4">
                            <div
                              className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder is-upgraded" 
                            >
                              <input
                                className="mdl-textfield__input"
                                type="text"
                                id=""
                                placeholder="Enter card start from"
                                value={cardStartRange}
                                disabled
                              />
                              <label className="mdl-textfield__label">
                                Start Range
                              </label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-4">
                            <div
                              className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder is-upgraded" 
                            >
                              <input
                                className="mdl-textfield__input"
                                type="number"
                                id=""
                                value={totalCard}
                                onChange={(e) => setTotalCard(e.target.value)}
                                placeholder="Enter Total Number of Card"
                              />
                              <label className="mdl-textfield__label">
                                Total cards
                              </label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-4 ">
                            <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
                              <input
                                className="mdl-textfield__input"
                                type="date"
                                id=""
                                value={cardExpDate}
                                onChange={(e) => setCardExpDate(e.target.value)}
                              />
                              <label className="mdl-textfield__label">
                                Card Expire Date
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  {/* <input type="reset" value="Reset" className="lbtn btngr" /> */}
                  <button disabled={checkDisable()} type="submit" value="value" className={`${checkDisable() ? "lbtn btngr" : "lbtn btnbl"}`} >
                    Add Card
                  </button>
                </div>
              </>
          )} 
          </div>
        </form>
      </div>
    </div>
  );
};
const mapStateToProps = ({
  token: { authenticated, token },
  user: { roMdn, currentUser },
}) => ({
  authenticated,
  token,
  roMdn,
  currentUser,
});

export default connect(mapStateToProps)(AddNewInventory);
